import { useCallback, useContext, useEffect, useState } from "react";
import { config } from "../../../../constant";
import { useElement, useLocale, useService } from "../../../../hooks";
import { NavigatorContext } from "../../../../context";

export const useMyPackages = () => {
  const { t } = useLocale();
  const Actor = useElement("Actor");
  const Img = useElement("Img");
  const { getLoggedInUserData } = useService("User");
  const { setTitle } = useService("Meta");
  const { getFormattedDate } = useService("Misc");
  const { navigateTo } = useContext(NavigatorContext);
  const { getUserOrders } = useService("Order");
  const { commonPageSize } = config;
  const [tableContent, settableContent] = useState(null);
  const activeShownTotal = commonPageSize;
  const [tableData, settableData] = useState([]);
  const activePackage = "";

  setTitle("My Packages List");

  const getPackagesData = useCallback(async () => {
    let query = {
      uid: getLoggedInUserData().uid,
    };
    const result = await getUserOrders(query);
    if (result.status) {
      if (result.data?.length !== 0) {
        let tableData = [];
        result.data.forEach((item, index) => {
          let cartData = JSON.parse(item.orderData).cartData,
            unpgradedPackages = [],
            found = false,
            packagesData = [];
          if (
            item.status === "paid" ||
            item.status === "processing" ||
            item.status === "shipped" ||
            item.status === "delivered" ||
            item.status === "completed"
          ) {
            cartData.forEach((e) => {
              if (e.type === "servicePackage") {
                found = true;
                e.orderId = item.uid;
                if (e.previousPackageId) unpgradedPackages.push(e);
                else packagesData.push(e);
              }
            });
            packagesData.forEach((el) => {
              unpgradedPackages.forEach((e) => {
                if (e.previousPackageId === String(el.tempUid))
                  el.title = e.title;
              });
              if (found) tableData.push(el);
            });
          }
        });
        settableData(tableData);
      }
    }
  }, [getLoggedInUserData, getUserOrders]);

  useEffect(() => {
    getPackagesData();
  }, [getPackagesData]);

  const getTableData = useCallback(
    (filterData) => {
      let data = [];
      filterData.forEach((item) => {
        if (
          item.status !== "initialised" &&
          typeof item.previousOrderId === "undefined" &&
          typeof item.previousPackageId === "undefined"
        ) {
          let el = {
            title: <span className="package-name">{item.title}</span>,
            startDate: getFormattedDate(new Date(item.startDate)),
            endDate: getFormattedDate(new Date(item.endDate)),
            car: (
              <li className="my-packages-assign-car">
                <Img
                  source="carCDN"
                  src={item.activeCar.image_path}
                  alt={item.activeCar.name + " " + item.activeCar?.Segment}
                />
                <div className="ml10">
                  <p>{item.activeCar.name + " " + item.activeCar?.Segment}</p>
                  {item.activeCar.registrationNo &&
                    item.activeCar.registrationNo !== "" &&
                    item.activeCar.registrationNo !== null && (
                      <small>{item.activeCar.registrationNo}</small>
                    )}
                </div>
              </li>
            ),
            action: (
              <div className="action-bar">
                <Actor
                  type="view"
                  onClick={() =>
                    navigateTo({
                      route:
                        "/package/view/" +
                        btoa(item.orderId + "/" + item.tempUid),
                    })
                  }
                />
              </div>
            ),
          };
          data.push(el);
        }
      });
      return data;
    },
    [Actor, Img, getFormattedDate, navigateTo]
  );

  useEffect(() => {
    settableContent({
      headers: [
        {
          label: t("name"),
          key: "name",
        },
        {
          label: t("startDate"),
          key: "startDate",
        },
        {
          label: t("endDate"),
          key: "endDate",
        },
        {
          label: "Assign Car",
          key: "assignCar",
        },
        {
          label: t("actions"),
          key: "actions",
        },
      ],
      content: getTableData(tableData),
    });
  }, [tableData, getTableData, t]);
  return {
    tableContent,
    activeShownTotal,
    activePackage,
  };
};
